var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"align-center",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"details-label",attrs:{"cols":"12","sm":"3"}},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),_c('v-col',{staticClass:"details-value",attrs:{"cols":"12","sm":"9"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }